import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy URL redirect: old shape was /{tenantSlug}/driver-onboarding/<page>;
// new shape is /carriers/{slug}/driver-onboarding/<page>. Catches any saved
// bookmark / email link pointing at the old paths and forwards them to the
// new location, preserving the tenant slug and the sub-path beneath
// /driver-onboarding/. Outside _auth on purpose so visitors without a
// session also get redirected before the login bounce.
export const Route = createFileRoute('/$tenantSlug/driver-onboarding/$')({
  beforeLoad: ({ params }) => {
    const { tenantSlug, _splat } = params
    const subPath = _splat ? `/${_splat}` : ''
    throw redirect({ href: `/carriers/${tenantSlug}/driver-onboarding${subPath}` })
  },
})
